import { createIcon } from '@chakra-ui/icons';

// hugeicons "book-04" — the Course Detail Pages row. Exported from the Academies Figma file.
export const BookOpen = createIcon({
  displayName: 'BookOpen',
  viewBox: '0 0 15.3333 18.6688',
  path: (
    <g>
      <path fill="none" d="M13.9525 1.00215H3.08334C1.93274 1.00215 1 1.93489 1 3.08548C1 3.12332 1.00101 3.16092 1.003 3.19826M1.003 3.19826C1.06158 4.29641 1.97058 5.16881 3.08333 5.16881H11C12.5713 5.16881 13.357 5.16881 13.8452 5.65697C14.3333 6.14512 14.3333 6.9308 14.3333 8.50215L14.3333 14.3355C14.3333 15.9068 14.3333 16.6925 13.8452 17.1807C13.357 17.6688 12.5713 17.6688 11 17.6688H6.003C3.64598 17.6688 2.46747 17.6688 1.73523 16.9366C1.003 16.2043 1.003 15.0258 1.003 12.6688V3.19826ZM1.003 3.19826V3.08654M13.9067 1.00021C11.9268 2.02882 12.0707 4.36479 13.3995 5.31272" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <path fill="none" d="M10.5833 9.75021H4.75M8.08333 13.0835H4.75" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </g>
  ),
});
